//https://www.youtube.com/watch?v=u3KlatzB7GM
import {createSlice} from "@reduxjs/toolkit";

//  this showed how to create the reducer
// https://stackoverflow.com/questions/68971771/react-redux-toolkit-action-in-dispatch-returns-err-object-is-not-a-functi

// const initialState = {value: {id: 0, mcode: "", name:"", description: ""}};

export const paymentSlice = createSlice({
    name: 'paymentSlc',
    initialState: {value: {
            myProductId: null, myGuildId: null, myR2m: null, myCdpId: null,
            updatePaymentGrid: false, paymentGridState: true, refreshPaymentGrid: false}},
    reducers:
        // {
        //     changePayment: (state, action) => {
        //         state.value = action.payload;
        //     },
        // }
{
    changePayment: (state, action) => {
        state.value = {
            ...state.value,  // Keep existing fields
            ...action.payload // Merge new values
        };
    }
}
});

export const {changePayment} = paymentSlice.actions;

export default  paymentSlice.reducer ;
